/** Must match backend FREE_SIGNUP_CREDITS default / .env. */
export const FREE_SIGNUP_CREDITS = 10

export function formatSignupCreditsLabel(count: number = FREE_SIGNUP_CREDITS): string {
  return `${count} ${count === 1 ? 'credit' : 'credits'}`
}

export function formatCreditsLabel(n: number): string {
  const abs = Math.abs(Math.round(n))
  return `${n} ${abs === 1 ? 'credit' : 'credits'}`
}
